import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-share-project-configuration',
  template: `
    <div class="popup rounded-2xl overflow-hidden">
    <div class="flex justify-end p-1 h-auto">
        <button type="button" class="close-x" (click)="close()" aria-label="Close">
          <span class="material-icons"> close </span>
        </button>
      </div>
      <div
        class="container w-auto p-4 bg-white rounded-lg shadow-sm border border-[#E5E7EB] h-[20rem] my-[1%] mx-auto overflow-y-auto overflow-x-hidden"
      >
        <div class="flex justify-center">
          <h1 class="font-bold text-lg">Share Project</h1>
        </div>
        <div
          class="user-card"
          *ngFor="let userObject of numberOfUsers"
        >
          <mat-form-field appearance="fill" class="d2c-field">
            <mat-label>Select User</mat-label>
            <mat-select [formControl]="userObject.usersControl">
              <mat-option *ngFor="let user of userList" [value]="user">{{
                user
              }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="d2c-field">
            <mat-label>Select Access Types</mat-label>
            <mat-select [formControl]="userObject.accesControl" multiple>
              <mat-option
                *ngFor="let access of accessLIst"
                [value]="access"
                >{{ access }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <button type="button" class="btn-ghost btn-add-user" (click)="addUsers()">
          + Add another user
        </button>
        <div class="flex justify-center">
          <button type="button" class="btn-primary" (click)="show()">
            Share Project
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./share-project-configuration.component.scss'],
})
export class ShareProjectConfigurationComponent {
  accessControl = new FormControl('');
  accessLIst = ['Read', 'Write', 'Execute', 'Delete'];
  userControl = new FormControl();
  userList = ['Amit', 'Aksash', 'Ajay'];
  numberOfUsers = [
    {
      usersControl: new FormControl(),
      accesControl: new FormControl(),
    },
  ];
  outputFormat = [];
  constructor(
    private dialogRef: MatDialogRef<ShareProjectConfigurationComponent>
  ) {}
  show() {
    this.numberOfUsers.forEach((users) => {
      let temp = {
        userName: users.usersControl.value,
        accessLIst: users.accesControl.value,
      };
    });
  }
  addUsers() {
    this.numberOfUsers.push({
      usersControl: new FormControl(),
      accesControl: new FormControl(),
    });
  }
  close() {
    this.dialogRef.close();
  }
}
